import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsOfServiceComponent implements OnInit {
  private firestore = inject(Firestore);
  termsContent = 'Loading...';

  async ngOnInit() {
    try {
      const docRef = doc(this.firestore, 'photobooth_config_published', 'legal');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        this.termsContent = docSnap.data()['termsOfService'] || 'No Terms of Service content found.';
      } else {
        this.termsContent = 'Terms of Service document not found in database.';
      }
    } catch (err) {
      console.error('Error fetching terms:', err);
      this.termsContent = 'Failed to load Terms of Service.';
    }
  }
}
